import React from "react";

const MainContainer = ({ children }) => {
  return (
    <div className="w-full min-h-screen bg-[#F8FBFF] p-5 rounded-lg">
      {children}
    </div>
  );
};

export default MainContainer;
